import { Location } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { QuotesService } from 'src/app/quotes/quotes.service';
import { DocumentTypeIdsEnum } from '../app-common-enum';
import { BolEditFormComponent } from '../bol-edit-form/bol-edit-form.component';
import { CommonDataModel } from '../common-data-model';
import { EmailGenerationFormComponent } from '../email-generation-form/email-generation-form.component';
import { HouseBillCustomEditFormComponent } from '../house-bill-custom-edit-form/house-bill-custom-edit-form.component';
import { HouseBillEditFormComponent } from '../house-bill-edit-form/house-bill-edit-form.component';
import { OrdersDocumentsListComponent } from '../orders-documents-list/orders-documents-list.component';

@Component({
    selector: 'app-orders-type-documents',
    templateUrl: './orders-type-documents.component.html',
    styleUrls: ['./orders-type-documents.component.scss']
})
export class OrdersTypeDocumentsComponent implements OnInit {

    componentSubscriptions: Subscription = new Subscription();
    @ViewChild('houseBill', { static: false }) houseBill: EmailGenerationFormComponent;
    @ViewChild('cutSheet', { static: false }) cutSheet: EmailGenerationFormComponent;
    @ViewChild('bol', { static: false }) bol: EmailGenerationFormComponent;
    @ViewChild('quote', { static: false }) quote: EmailGenerationFormComponent;
    @ViewChild('shipping', { static: false }) shipping: EmailGenerationFormComponent;
    @ViewChild('invoice', { static: false }) invoice: EmailGenerationFormComponent;
    @ViewChild('shipped', { static: false }) shipped: EmailGenerationFormComponent;

    @ViewChild('houseBillDocs', { static: false }) houseBillDocs: OrdersDocumentsListComponent;
    @ViewChild('cutSheetDocs', { static: false }) cutSheetDocs: OrdersDocumentsListComponent;
    @ViewChild('bolDocs', { static: false }) bolDocs: OrdersDocumentsListComponent;
    @ViewChild('quoteDocs', { static: false }) quoteDocs: OrdersDocumentsListComponent;
    @ViewChild('shippingDocs', { static: false }) shippingDocs: OrdersDocumentsListComponent;
    @ViewChild('invoiceDocs', { static: false }) invoiceDocs: OrdersDocumentsListComponent;
    @Output() activate: EventEmitter<any> = new EventEmitter<any>();
    commonDataModel = new CommonDataModel();
    houseBillTotalTypes = this.commonDataModel.getHouseBillTotalTypes();
    houseBillingForm = this.commonDataModel.houseBillingFormModel;
    tempHouseBillingForm = _.cloneDeep(this.commonDataModel.houseBillingFormModel);
    cutSheetForm = this.commonDataModel.cutSheetFormModel;
    tempCutSheetForm = _.cloneDeep(this.commonDataModel.cutSheetFormModel);
    bolForm = this.commonDataModel.bolFormModel;
    tempBolForm = _.cloneDeep(this.commonDataModel.bolFormModel);
    shippingForm = this.commonDataModel.shippingFormModel;
    tempShippingForm = _.cloneDeep(this.commonDataModel.shippingFormModel);
    invoiceForm = this.commonDataModel.invoiceFormModel;
    tempInvoiceForm = _.cloneDeep(this.commonDataModel.invoiceFormModel);
    orderShippedForm = this.commonDataModel.notificationOfArrivalFormModel;
    tempShippedForm = _.cloneDeep(this.commonDataModel.notificationOfArrivalFormModel);
    quoteForm = this.commonDataModel.quoteFormModel;
    tempQuoteForm = _.cloneDeep(this.commonDataModel.quoteFormModel);
    orderDetails: any;
    houseBillTypeList: any;
    orderId: any;
    orderDisplayId: any;
    documentConfigs: any;
    isCutSheetSendToMail = false;
    isCutBolSendToMail = false;
    isQuoteToMail = false;
    isShippinglableToMail = false;
    isInvoiceToMail = false;
    isOrderCarrierPickup = false;
    isFormLoading = false;
    isQuickQuote = false;
    quoteDocumentTypes = this.commonDataModel.quoteDocumentTypes;
    documentTypeEnum: typeof DocumentTypeIdsEnum = DocumentTypeIdsEnum;
    selectedDocumentTypeId = 2;
    statusUpdateModel = this.commonDataModel.ordersBulkStatusUpdateModel;
    statusList = [];
    minDate = moment().subtract(21, 'days').format();
    minPickupDate = moment().subtract(3, 'weeks').format();

    constructor(
        private location: Location,
        public dialog: MatDialog,
        private toastr: ToastrService,
        private quotesService: QuotesService,
        private activatedRoute: ActivatedRoute,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
    ) { }

    ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
        }
        this.getDocumentConfigs();
        this.onGetOrderDetailsAccount();
        this.getHouseBillTypeLookup();
        this.invoiceForm.invoiceDate = moment().format();
        this.componentSubscriptions.add(
            this.commonMethod.getOrderId.subscribe(data => {
                this.orderDisplayId = data ? data : 0;
            })
        )
    }

    getOrderStatus() {
        let queryString = `IsJob=${this.orderDetails.isJob ? true : false}`;
        if (this.orderId) {
            queryString += `&OrderId=${this.orderDetails.id}`;
        }
        this.commonService.getOrderStatus(queryString).subscribe((response: any) => {
            this.statusList = response.data;
        });
    }

    onDocumentTabChange(event: any) {
        switch (event.tab.textLabel) {
            case 'House Bill':
                this.selectedDocumentTypeId = this.documentTypeEnum.houseBill;
                break;
            case 'Cut Sheet':
                this.selectedDocumentTypeId = this.documentTypeEnum.cutSheet;
                break;
            case 'BOL':
                this.selectedDocumentTypeId = this.documentTypeEnum.bol;
                break;
            case 'Quote':
                if (this.quoteForm.documentType === 'Estimate') {
                    this.selectedDocumentTypeId = this.documentTypeEnum.estimate;
                } else {
                    this.selectedDocumentTypeId = this.documentTypeEnum.quote;
                }
                break;
            case 'Shipping Label':
                this.selectedDocumentTypeId = this.documentTypeEnum.shippingLabel;
                break;
            case 'Invoice':
                this.selectedDocumentTypeId = this.documentTypeEnum.invoice;
                break;
            case 'Your Order Has Shipped':
                this.selectedDocumentTypeId = this.documentTypeEnum.statusChangeCarrierPickup;
                break;
            default:
                this.selectedDocumentTypeId = null;
                break;
        }
        this.getDocumentConfigs();
    }

    getDocumentConfigs() {
        this.quotesService.getDocumentConfig(this.orderId, this.selectedDocumentTypeId).subscribe(response => {
            if (response.isSuccess) {
                this.documentConfigs = _.cloneDeep(response.data);
                this.quoteForm.notes = this.documentConfigs.quoteNotes;
                this.shippingForm.shippingLabel = this.documentConfigs.shippingLabel;
                this.houseBillingForm.houseBillTotal = this.documentConfigs.houseBillTotal ? this.documentConfigs.houseBillTotal : 1;
                this.houseBillingForm.houseBillTypeId = this.setDefaultHouseBill(this.documentConfigs.houseBillTypeId);
                this.houseBillingForm.pickupDate = response.data.pickupDate ? response.data.pickupDate : null;
            }
        });
    }

    setDefaultHouseBill(insurancCatId: any) {
        switch (insurancCatId) {
            case 1: return 1;
                break;
            case 2: return 4;
                break;
            case 3: return 2;
                break;
            case 4: return 3;
                break;
            case 5: return 5;
                break;
            default: return 1;
                break;
        }

    }

    onEditHouseBillOpenDialog(): void {
        let dialogComponent;
        if (this.houseBillingForm.houseBillTypeId === 5) {
            dialogComponent = HouseBillCustomEditFormComponent;
        } else {
            dialogComponent = HouseBillEditFormComponent;
        }
        this.dialog.open(dialogComponent, {
            panelClass: 'document_bill_center_layout',
            hasBackdrop: false,
            data: { billDetails: {} },
            autoFocus: false
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult) {

                }
            });
    }

    onEditBOLOpenDialog(): void {
        this.dialog.open(BolEditFormComponent, {
            panelClass: 'document_bill_center_layout',
            hasBackdrop: false,
            data: { billDetails: {} },
            autoFocus: false
        }).afterClosed()
            .subscribe((response: any) => {
                if (response && response.confirmResult) {

                }
            });
    }

    onHouseBillPublish() {
        this.onHouseBillPublishContinue();
    }

    onHouseBillPublishContinue() {
        this.houseBillingForm.orderId = this.orderId;
        this.houseBillingForm.emailDetails = this.houseBill.emailForm;
        const houseBillingForm = _.cloneDeep(this.houseBillingForm);
        if (houseBillingForm.isSendEmail) {
            if (!this.houseBill.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.houseBill.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.houseBill.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(houseBillingForm.emailDetails, this.houseBill);
        delete houseBillingForm.emailDetails.bccToMyself;
        delete houseBillingForm.emailDetails.toMyself;
        delete houseBillingForm.isview;
        this.isFormLoading = true;
        this.commonService.publishDocument(houseBillingForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.houseBillDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    setAdditionalEmails(addIn, addFrom) {
        // additional for To email
        if (addFrom.toFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.toToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.toPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.toIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for to myself email
        if (addFrom.emailForm.toMyself && addFrom.documentConfigData.meEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.meEmail}` : addFrom.documentConfigData.meEmail;
        }
        // additional for Cc email
        if (addFrom.ccFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.ccToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.ccPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.ccIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for Bcc email
        if (addFrom.emailForm.bccToMyself && addFrom.documentConfigData.meEmail) {
            addIn.bcc += (addIn.bcc) ? `;${addFrom.documentConfigData.meEmail}` : addFrom.documentConfigData.meEmail;
        }
    }

    onViewDocument() {
        this.houseBillingForm.orderId = this.orderId;
        this.houseBillingForm.emailDetails = this.houseBill.emailForm;
        const houseBillingForm = _.cloneDeep(this.houseBillingForm);
        this.setAdditionalEmails(houseBillingForm.emailDetails, this.houseBill);
        this.isFormLoading = true;
        this.commonService.viewDocument(houseBillingForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    toEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.toEmailValidationMessage);
    }

    ccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.ccEmailValidationMessage);
    }

    bccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.bccEmailValidationMessage);
    }

    onCutsheetViewDocument() {
        this.cutSheetForm.orderId = this.orderId;
        this.cutSheetForm.emailDetails = this.cutSheet.emailForm;
        const cutSheetForm = _.cloneDeep(this.cutSheetForm);
        this.setAdditionalEmails(cutSheetForm.emailDetails, this.cutSheet);
        this.isFormLoading = true;
        this.commonService.cutSheetViewDocument(cutSheetForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                if (response.status === 200) {
                    this.isFormLoading = false;
                    const data: any = response;
                    this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
                } else if (response.status === 204) {
                    this.toastr.warning('There is no Crate Available for this Job');
                }
            });
    }

    onCutSheetPublish() {
        this.onCutSheetPublishContinue();
    }

    onCutSheetPublishContinue() {
        this.cutSheetForm.orderId = this.orderId;
        this.cutSheetForm.emailDetails = this.cutSheet.emailForm;
        const cutSheetForm = _.cloneDeep(this.cutSheetForm);
        if (cutSheetForm.isSendEmail) {
            if (!this.cutSheet.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.cutSheet.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.cutSheet.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(cutSheetForm.emailDetails, this.cutSheet);
        delete cutSheetForm.emailDetails.bccToMyself;
        delete cutSheetForm.emailDetails.toMyself;
        delete cutSheetForm.isview;
        this.isFormLoading = true;
        this.commonService.cutSheetPublishDocument(cutSheetForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.cutSheetDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onBolPublish() {
        this.onBolPublishContinue();
    }

    onBolPublishContinue() {
        this.bolForm.orderId = this.orderId;
        this.bolForm.emailDetails = this.bol.emailForm;
        const bolForm = _.cloneDeep(this.bolForm);
        if (bolForm.isSendEmail) {
            if (!this.bol.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.bol.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.bol.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(bolForm.emailDetails, this.bol);
        delete bolForm.emailDetails.bccToMyself;
        delete bolForm.emailDetails.toMyself;
        delete bolForm.isview;
        this.isFormLoading = true;
        this.commonService.bolPublishDocument(bolForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.bolDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onBOLViewDocument() {
        this.bolForm.orderId = this.orderId;
        this.bolForm.emailDetails = this.bol.emailForm;
        const bolForm = _.cloneDeep(this.bolForm);
        this.setAdditionalEmails(bolForm.emailDetails, this.bol);
        this.isFormLoading = true;
        this.commonService.bolViewDocument(bolForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    quoteDocumentTypeChange(event: any) {
        if (event.value === 'Estimate') {
            this.selectedDocumentTypeId = this.documentTypeEnum.estimate;
        } else {
            this.selectedDocumentTypeId = this.documentTypeEnum.quote;
        }
        this.getDocumentConfigs();
    }

    onQuotePublish() {
        if (this.quoteForm.isSendEmail && this.orderDetails.statusId === 1 &&
            !this.orderDetails.isJob && !this.orderDetails.isQuickQuote) {
            this.statusUpdateModel.isLocked = true;
            this.statusUpdateModel.orderId = [this.orderDetails.orderId];
            this.statusUpdateModel.statusId = 2;
            this.statusUpdateModel.statusName = this.statusList.find(item => item.id === 2).name;
            this.statusUpdateModel.notes = '';
            this.statusUpdateModel.serviceDate = moment().format();
            this.statusUpdateModel.serviceTime = moment(this.statusUpdateModel.serviceDate).format('HH:mm:ss');
            this.isFormLoading = true;
            this.commonService.orderBulkUpdate(this.statusUpdateModel).subscribe((response: any) => {
                if (response.isSuccess) {
                    this.onQuotePublishContinue();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
        } else {
            this.onQuotePublishContinue();
        }
    }

    onQuotePublishContinue() {
        this.quoteForm.orderId = this.orderId;
        this.quoteForm.emailDetails = this.quote.emailForm;
        const quoteForm = _.cloneDeep(this.quoteForm);
        if (quoteForm.isSendEmail) {
            if (!this.quote.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.quote.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.quote.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(quoteForm.emailDetails, this.quote);
        delete quoteForm.emailDetails.bccToMyself;
        delete quoteForm.emailDetails.toMyself;
        delete quoteForm.isview;
        this.isFormLoading = true;
        this.commonService.quotePublishDocument(quoteForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.quoteDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onQuoteViewDocument() {
        this.quoteForm.orderId = this.orderId;
        this.quoteForm.emailDetails = this.quote.emailForm;
        const quoteForm = _.cloneDeep(this.quoteForm);
        this.setAdditionalEmails(quoteForm.emailDetails, this.quote);
        this.isFormLoading = true;
        this.commonService.quoteViewDocument(quoteForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    onShipplingLabelPublish() {
        this.onShipplingLabelPublishContinue();
    }

    onShipplingLabelPublishContinue() {
        this.shippingForm.orderId = this.orderId;
        this.shippingForm.emailDetails = this.shipping.emailForm;
        const shippingForm = _.cloneDeep(this.shippingForm);
        if (shippingForm.isSendEmail) {
            if (!this.shipping.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.shipping.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.shipping.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(shippingForm.emailDetails, this.shipping);
        delete shippingForm.emailDetails.bccToMyself;
        delete shippingForm.emailDetails.toMyself;
        delete shippingForm.isview;
        this.isFormLoading = true;
        this.commonService.shippingLabelPublishDocument(shippingForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.shippingDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onShippingLabelViewDocument() {
        this.shippingForm.orderId = this.orderId;
        this.shippingForm.emailDetails = this.shipping.emailForm;
        const shippingForm = _.cloneDeep(this.shippingForm);
        this.setAdditionalEmails(shippingForm.emailDetails, this.shipping);
        this.isFormLoading = true;
        this.commonService.shippingLabelViewDocument(shippingForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    onInvoicePublish() {
        this.onInvoicePublishContinue();
    }

    onInvoicePublishContinue() {
        this.invoiceForm.orderId = this.orderId;
        this.invoiceForm.emailDetails = this.invoice.emailForm;
        const invoiceForm = _.cloneDeep(this.invoiceForm);
        if (invoiceForm.isSendEmail) {
            if (!this.invoice.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.invoice.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.invoice.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        invoiceForm.invoiceDate = moment(this.invoiceForm.invoiceDate).utcOffset(0, true).format();
        this.setAdditionalEmails(invoiceForm.emailDetails, this.invoice);
        delete invoiceForm.emailDetails.bccToMyself;
        delete invoiceForm.emailDetails.toMyself;
        delete invoiceForm.isview;
        this.isFormLoading = true;
        this.commonService.invoicePublishDocument(invoiceForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    this.invoiceDocs.onRefreshGridData();
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onInvoiceViewDocument() {
        this.invoiceForm.orderId = this.orderId;
        this.invoiceForm.emailDetails = this.invoice.emailForm;
        const invoiceForm = _.cloneDeep(this.invoiceForm);
        this.setAdditionalEmails(invoiceForm.emailDetails, this.invoice);
        this.isFormLoading = true;
        invoiceForm.invoiceDate = moment(this.invoiceForm.invoiceDate).utcOffset(0, true).format();
        this.commonService.invoiceViewDocument(invoiceForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

    onOrderShipped() {
        this.orderShippedForm.orderId = this.orderId;
        this.orderShippedForm.emailDetails = this.shipped.emailForm;
        const orderShippedForm = _.cloneDeep(this.orderShippedForm);
        if (orderShippedForm.isSendEmail) {
            if (!this.shipped.isEmailtoValid()) {
                return this.toEmailValidationMessage();
            }
            if (!this.shipped.isEmailccValid()) {
                return this.ccEmailValidationMessage();
            }
            if (!this.shipped.isEmailbccValid()) {
                return this.bccEmailValidationMessage();
            }
        }
        this.setAdditionalEmails(orderShippedForm.emailDetails, this.shipped);
        delete orderShippedForm.emailDetails.bccToMyself;
        delete orderShippedForm.emailDetails.toMyself;
        delete orderShippedForm.isview;
        this.isFormLoading = true;
        this.commonService.notificationOfArrivalDocument(orderShippedForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                } else {
                    this.toastr.error(response.errors || CommonConstants.appComponent.somethingWenWrongPleaseReTry, CommonConstants.appComponent.error);
                }
            });
    }

    onGetOrderDetailsAccount(): void {
        this.isFormLoading = true;
        this.quotesService.getQuote(this.orderId)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.orderDetails = response.data;
                    this.quotesService.setAccountID(this.orderDetails.account.accountId);
                    this.isQuickQuote = response.data.isQuickQuote;
                    this.isOrderCarrierPickup = this.orderDetails.statusId === 10 ? true : false;
                    if (this.isQuickQuote) {
                        this.quoteForm.documentType = 'Estimate';
                        this.selectedDocumentTypeId = this.documentTypeEnum.estimate;
                        this.getDocumentConfigs();
                    }
                    this.getOrderStatus();
                }
            });
    }

    getHouseBillTypeLookup(): void {
        this.commonService.getHouseBillTypeLookup().subscribe(response => {
            if (response.isSuccess) {
                this.houseBillTypeList = response.data;
            }
        });
    }

    onSavePickupDate(): void {
        this.isFormLoading = true;
        //this.houseBillingForm.pickupDate = moment(this.houseBillingForm.pickupDate).format();
        this.houseBillingForm.pickupDate = moment(this.houseBillingForm.pickupDate).utcOffset(0, true).format();
        const payload = {
            orderId: this.orderDisplayId,
            documentType: this.documentTypeEnum.houseBill,
            pickupDate: this.houseBillingForm.pickupDate
        }
        this.commonService.postPickupDate(payload)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                } else {
                    this.toastr.error(response.errors);
                }
                this.getDocumentConfigs();
            })
    }

    deletePickupDate(): void {
        this.isFormLoading = true;
        this.houseBillingForm.pickupDate = moment(this.houseBillingForm.pickupDate).utcOffset(0, true).format();
        const payload = {
            orderId: this.orderDisplayId,
            pickupDate: this.houseBillingForm.pickupDate
        }
        this.commonService.deletePickupDate(payload)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.houseBillingForm.pickupDate = null;
                    this.toastr.success(response.errors);
                } else {
                    this.toastr.error(response.errors);
                }
                this.getDocumentConfigs();
            })
    }

    onResetHouseBillForm() {
        this.houseBillingForm = Object.assign({}, this.tempHouseBillingForm);
        this.houseBill.resetForm();
    }

    onResetCutSheetForm() {
        this.cutSheetForm = Object.assign({}, this.tempCutSheetForm);
        this.cutSheet.resetForm();
    }

    onResetBOLForm() {
        this.bolForm = Object.assign({}, this.tempBolForm);
        this.bol.resetForm();
    }

    onResetQuoteForm() {
        this.quoteForm = Object.assign({}, this.tempQuoteForm);
        this.quote.resetForm();
    }

    onResetShippingLabelForm() {
        this.shippingForm = Object.assign({}, this.tempShippingForm);
        this.shipping.resetForm();
    }

    onResetInvoiceForm() {
        this.invoiceForm = Object.assign({}, this.tempInvoiceForm);
        this.invoice.resetForm();
    }

    onResetShippedForm() {
        this.orderShippedForm = Object.assign({}, this.tempShippedForm);
        this.shipped.resetForm();
    }

    onGoBack(): void {
        this.location.back();
    }

    onChangeDate(event: any) {
        this.invoiceForm.invoiceDate = moment(event.value).format();
    }
}
